import React, {Component} from 'react';
import PropTypes from 'prop-types';

class DataColumn extends Component {
    static propTypes = {
        fieldName: PropTypes.string,
        type: PropTypes.string.isRequired,
        caption: PropTypes.string,
        cell: PropTypes.func.isRequired
    };
    static defaultProps = {
        fieldName: null,
        caption: null
    };
    state = {};

    render() {
        return (
            <div></div>
        );
    }
}

export default DataColumn;


// WEBPACK FOOTER //
// ./src/datagrid/DataColumn.js